import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../components/Layout';
import Menu from '../../components/Layout/Menu';

const UsersContent = lazy(() => import('../../components/Pages/Users'));

export default function Users(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: User List page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <UsersContent />
      </Suspense>
    </Layout>
  );
}
